import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a8876da4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-content--supporter" }
const _hoisted_2 = { class: "info-item info-item--md-half" }
const _hoisted_3 = { class: "profile-content-row profile-content__tags" }
const _hoisted_4 = { class: "profile-content__caption" }
const _hoisted_5 = {
  key: 0,
  class: "el-tag__subtitle"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "profile-content__label-wrapper"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "profile-content-row profile-content__tags" }
const _hoisted_10 = { class: "profile-content__caption" }
const _hoisted_11 = {
  key: 0,
  class: "el-tag__subtitle"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "profile-content__label-wrapper"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "info-item info-item--md-half" }
const _hoisted_16 = { class: "profile-content-row" }
const _hoisted_17 = { class: "profile-content__caption" }
const _hoisted_18 = { class: "profile-content__data" }
const _hoisted_19 = {
  key: 0,
  class: "profile-content__empty-data"
}
const _hoisted_20 = { class: "profile-content-row" }
const _hoisted_21 = { class: "profile-content__caption" }
const _hoisted_22 = { class: "profile-content__data" }
const _hoisted_23 = {
  key: 1,
  class: "profile-content__empty-data"
}
const _hoisted_24 = { class: "profile-content-row" }
const _hoisted_25 = { class: "profile-content__caption" }
const _hoisted_26 = { class: "profile-content__data" }
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 2,
  class: "profile-content__empty-data"
}
const _hoisted_29 = {
  key: 0,
  class: "profile-content-row"
}
const _hoisted_30 = { class: "profile-content__caption" }
const _hoisted_31 = ["textContent"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-question" }, null, -1))
const _hoisted_33 = { class: "profile-content__data" }
const _hoisted_34 = ["href"]
const _hoisted_35 = {
  key: 3,
  class: "profile-content__hidden-email"
}
const _hoisted_36 = { class: "profile-content__hidden-email-title" }
const _hoisted_37 = { class: "profile-content__hidden-email-subtitle" }
const _hoisted_38 = {
  key: 4,
  class: "profile-content__empty-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_PxMoreList = _resolveComponent("PxMoreList")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_PxIcon = _resolveComponent("PxIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.supporterSectorsTitle), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitVisible(_ctx.supporterSectorsOfInterest), (sector, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "profile-content__tags-wrapper"
          }, [
            _createVNode(_component_ElTag, {
              effect: "plain",
              class: "text--capitalize"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(sector.name) + " ", 1),
                (sector.items)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(sector.items.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128)),
        (_ctx.hasMore(_ctx.supporterSectorsOfInterest))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_PxMoreList, {
                "modal-title": _ctx.supporterSectorsTitle,
                values: _ctx.getListOfNamesWithCount(_ctx.supporterSectorsOfInterest),
                "values-item-list": _ctx.supporterSectorsOfInterest
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_PxButton, {
                    class: "el-button--link el-button--small el-button--link-dark",
                    type: "link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("common.seeAll", {
                    number: _ctx.getTotal(_ctx.supporterSectorsOfInterest),
                  })), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modal-title", "values", "values-item-list"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.supporterSectorsOfInterest.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.$user.isOwner())
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("profile.company.emptyState.sectorsOfInterest[0]")), 1),
                    _createVNode(_component_PxButton, {
                      class: "el-button--link el-button--link-blue",
                      type: "link",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickFieldHandler({ view: 'interests' })))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.sectorsOfInterest[1]")), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_ctx.hasUserAccess)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("profile.company.emptyState.sectorsOfInterest[2]")), 1))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.supporterLocationsTitle), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitVisible(
            _ctx.supporterLocationsOfInterest,
          ), (location, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "profile-content__tags-wrapper"
          }, [
            _createVNode(_component_ElTag, {
              effect: "plain",
              class: "text--capitalize"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(location.name) + " ", 1),
                (location.items)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " (" + _toDisplayString(location.items.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128)),
        (_ctx.hasMore(_ctx.supporterLocationsOfInterest))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_PxMoreList, {
                "modal-title": _ctx.supporterLocationsTitle,
                values: _ctx.getListOfNamesWithCount(_ctx.supporterLocationsOfInterest),
                "values-item-list": _ctx.supporterLocationsOfInterest
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_PxButton, {
                    class: "el-button--link el-button--small el-button--link-dark",
                    type: "link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("common.seeAll", {
                    number: _ctx.getTotal(_ctx.supporterLocationsOfInterest),
                  })), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modal-title", "values", "values-item-list"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.supporterLocationsOfInterest.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.$user.isOwner())
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("profile.company.emptyState.locationsOfInterest[0]")), 1),
                    _createVNode(_component_PxButton, {
                      class: "el-button--link el-button--link-blue",
                      type: "link",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickFieldHandler({ view: 'interests' })))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.locationsOfInterest[1]")), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_ctx.hasUserAccess)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("profile.company.emptyState.locationsOfInterest[2]")), 1))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.$t("profile.company.supporterTypes")), 1),
        _createElementVNode("div", _hoisted_18, [
          _createTextVNode(_toDisplayString(_ctx.supporterTypes) + " ", 1),
          (!_ctx.supporterTypes && !_ctx.$user.isOwner())
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("profile.company.emptyState.visitor")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.$t("profile.company.about")), 1),
        _createElementVNode("div", _hoisted_22, [
          _createTextVNode(_toDisplayString(_ctx.company.about) + " ", 1),
          (!_ctx.company.about && _ctx.$user.isOwner())
            ? (_openBlock(), _createBlock(_component_PxButton, {
                key: 0,
                class: "el-button--link el-button--link-blue",
                type: "link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickFieldHandler({ view: 'general', field: 'about' })))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.about")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.company.about && !_ctx.$user.isOwner())
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t("profile.company.emptyState.visitor")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.$t("profile.company.website")), 1),
        _createElementVNode("div", _hoisted_26, [
          (_ctx.company.website)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.companyWebsite,
                class: "el-button el-button--link el-button--link-dark",
                target: "_blank"
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.company.website), 1)
              ], 8, _hoisted_27))
            : (_ctx.$user.isOwner())
              ? (_openBlock(), _createBlock(_component_PxButton, {
                  key: 1,
                  class: "el-button--link el-button--link-blue",
                  type: "link",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickFieldHandler({ view: 'general', field: 'website' })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.website")), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t("profile.company.emptyState.visitor")), 1))
        ])
      ]),
      (_ctx.hasUserAccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("h4", _hoisted_30, [
              _createTextVNode(_toDisplayString(_ctx.$t("profile.company.email")) + " ", 1),
              (_ctx.$user.isOwner())
                ? (_openBlock(), _createBlock(_component_ElTooltip, {
                    key: 0,
                    placement: "top",
                    "popper-class": "profile-content__caption-tooltip el-abaca-tooltip"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        textContent: _toDisplayString(_ctx.$t(`profile.company.tooltip.emailVisibility`))
                      }, null, 8, _hoisted_31)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              (_ctx.canShowEmail)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `mailto:${_ctx.company.email}`,
                    class: "el-button el-button--link el-button--link-dark"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.company.email), 1)
                  ], 8, _hoisted_34))
                : (_ctx.$user.isOwner())
                  ? (_openBlock(), _createBlock(_component_PxButton, {
                      key: 1,
                      class: "el-button--link el-button--link-blue",
                      type: "link",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClickFieldHandler({ view: 'general', field: 'email' })))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("profile.company.emptyState.email")), 1)
                      ]),
                      _: 1
                    }))
                  : (!_ctx.hasUserAccess)
                    ? (_openBlock(), _createBlock(_component_PxButton, {
                        key: 2,
                        class: "el-button--link el-button--link-green",
                        type: "link",
                        onClick: _ctx.onClickSignUp
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("profile.company.visitorState.email")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_ctx.userCanMatch)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("p", _hoisted_36, [
                            _createVNode(_component_PxIcon, {
                              name: 'icon-password',
                              size: 12
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                  `profile.company.hiddenEmail[${
                    _ctx.userIsInterested ? 1 : 0
                  }].title`,
                  { name: _ctx.company.name },
                )), 1)
                          ]),
                          _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t(
                  `profile.company.hiddenEmail[${
                    _ctx.userIsInterested ? 1 : 0
                  }].subtitle`,
                )), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t("profile.company.emptyState.visitor")), 1))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}